var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFDA44"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2001D"
    },
    d: "M512,256c0-87.861-44.269-165.375-111.713-211.478H111.713C44.27,90.625,0,168.139,0,256 c0,87.863,44.27,165.375,111.713,211.478h288.574C467.731,421.375,512,343.863,512,256z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "200.348,189.217 311.652,189.217 311.652,144.696 289.391,155.826 256,122.435  222.609,155.826 200.348,144.696  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M356.174,256h-55.631c2.182-3.774,3.45-8.141,3.45-12.813c0-14.187-11.501-25.686-25.686-25.686 c-9.801,0-18.313,5.492-22.644,13.562c-4.331-8.071-12.843-13.562-22.644-13.562c-14.185,0-25.686,11.499-25.686,25.686 c0,4.673,1.27,9.04,3.45,12.813h-54.959c0,17.023,14.827,30.822,31.849,30.822h-1.026c0,13.963,9.287,25.753,22.02,29.54 l-25.017,25.019l23.611,23.611l33.493-33.493c1.312,0.481,2.669,0.865,4.072,1.129l-20.238,45.695 c9.698,3.944,20.297,6.133,31.412,6.133c11.114,0,21.713-2.189,31.412-6.133l-20.238-45.695c1.402-0.263,2.759-0.648,4.07-1.129 l33.493,33.493l23.61-23.611l-25.018-25.018c12.732-3.789,22.02-15.577,22.02-29.54h-1.027 C341.346,286.822,356.174,273.023,356.174,256z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6DA544"
    },
    points: "256,272.696 219.826,289.391 219.826,322.783 256,345.043 292.174,322.783 292.174,289.391  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.826,
    y: 256,
    style: {
      fill: "#0052B4"
    },
    width: 72.348,
    height: 44.522
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMe);
export default __webpack_public_path__ + "static/media/me.88bf212363c04f916e868166a589b26c.svg";
export { ForwardRef as ReactComponent };